<template>
  <van-col style="width: 100%; background-color: #f7f7f7;">
    <div class="team-process-title">
      <div class="team-process-line"></div>
      <div class="team-process-text">团队加入审核</div>
    </div>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="margin-top: 12px;">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check=false>
        <van-cell-group v-for="(item, index) in list" :key="index" style="margin-bottom: 12px;" inset>
          <van-cell title="姓名" :value="item.name" :border="false" />
          <van-cell title="电话" :value="item.account" :border="false" />
          <van-cell title="身份证号" :value="item.identityCard" :border="false" />
          <van-cell title="性别" :value="getSexStr(item.sex)" :border="false" />
          <van-cell title="日期" :value="item.updateTime" :border="true" />
          <div class="team-process-container">
            <div class="team-process-item" @click="onClickRefuse(item)">拒绝</div>
            <div class="team-process-divider"></div>
            <div class="team-process-item" style="color: #3a71ffff;" @click="onClickAgree(item)">同意</div>
          </div>
        </van-cell-group>
      </van-list>
    </van-pull-refresh>

    <van-dialog v-model="showDialog" :show-confirm-button="false" ref="dialog">
      <van-col class="team-process-register">
        <div>拒绝原因</div>
        <van-field v-model="refuseNoPass.remark" placeholder="请输入拒绝原因" rows="5" type="textarea"
          class="team-process-edit" clearable />
        <van-button round type="info" style="width: 100%;" @click="onClickRefuseSub">确定</van-button>
      </van-col>
    </van-dialog>
  </van-col>
</template>

<script>

import request from "@/utils/request";
import user from '@/utils/user'
import { Toast } from 'vant';

export default {
  data() {
    return {
      showDialog: false,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      listQuery: {
        pageInfo: {
          pageSize: 10,
          page: 1,
          totalCount: 0
        },
        orderBy: "createTime",
        orderAsc: false,
        status: 5,
      },
      refuseNoPass: {
        id: "",
        remark: "",
      },
    };
  },
  created() {
    var duty = user.getUserDuty()
    if (duty == 3) {
      this.onRefresh()
    } else {
      this.$router.replace({ name: 'noPermission' });
    }
  },
  methods: {
    getSexStr(value) {
      var s = ""
      if (value == 0) {
        s = "男"
      } else {
        s = "女"
      }
      return s;
    },
    onClickRefuse(item) {
      this.refuseNoPass.id = item.id;
      this.showDialog = true;
    },
    onClickRefuseSub() {
      var filterFomr = Object.assign({}, this.refuseNoPass);
      request.post("/User/AccountAudit/NoPass", filterFomr)
        .then(() => {
          Toast("操作成功")
          this.onRefresh()
        })
        .catch(() => { });
      this.showDialog = false;
    },
    onClickAgree(item) {
      request.get("/User/AccountAudit/Pass", { params: { id: item.id } })
        .then(() => {
          Toast("操作成功")
          this.onRefresh()
        })
        .catch(() => { });
    },
    onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
        this.listQuery.page = 1;
      }

      var filterFomr = Object.assign({}, this.listQuery);
      request.post("/User/AccountAudit/Query", filterFomr).then((res) => {
        this.listQuery.page = res.data.data.pageInfo.page + 1;
        this.list = res.data.data.data;
        this.finished = !res.data.data.pageInfo.hasMore;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
  }
};
</script>

<style lang="less">
.team-process-container {
  display: flex;
  align-items: center;
  /* 垂直居中 */
}

.team-process-item {
  flex: 1;
  /* 让项目平分容器宽度 */
  text-align: center;
  /* 文本居中 */
}

.team-process-divider {
  width: 1px;
  /* 分割线的宽度 */
  height: 40px;
  /* 分割线的高度，根据需要调整 */
  background-color: #f7f7f7;
  /* 分割线的颜色 */
}

.team-process-title {
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 12px;
  width: 100%;
}

.team-process-tags {
  display: flex;
  align-items: center;
}

.team-process-center {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
}

.team-process-line {
  background-color: #3a71ffff;
  border-radius: 4px;
  margin: 3px;
  width: 4px;
  height: 16px;
}

.team-process-text {
  color: #333;
  margin-left: 6px;
}

.team-process-register {
  width: 100%;
  padding: 20px;
}

.team-process-edit {
  background: #3a71ff1a;
  border: 1px solid #3a71ffff;
  border-radius: 12px;
  margin: 12px 0px;
}
</style>
